import {getMarketingProductAttributes} from './getMarketingProductAttributes'
import {buildItem, GA4_DEFAULT_CURRENCY, pushEcommerceEvent, sumItemsValue} from './ga4DataLayer'

export const triggerAddToCartEvent = ({product, variant, qyt, isInStorePickUp, usid, category}) => {
    const {c_AvailableForShipToStore, c_availableForInStorePickup, master} = product
    const orderType = isInStorePickUp ? 'BOPIS' : 'Ship'
    const bopisEligible = c_AvailableForShipToStore || c_availableForInStorePickup ? 'Yes' : 'No'
    const id = master?.masterId || product.id

    const items = [
        {
            ...buildItem({
                itemId: id,
                itemName: product?.name,
                index: 0,
                brand: product?.brand,
                categoryNames: category?.parentCategoryTree?.map((cat) => cat.name),
                variant: variant?.productId || product?.id,
                price: variant?.price ?? product?.price,
                quantity: qyt
            }),
            ...getMarketingProductAttributes(product),
            ATS: product?.inventory?.ats || 0,
            bopis_eligible: bopisEligible,
            bopis_type: orderType,
            ship_type: orderType,
            onlineFlag: true
        }
    ]

    pushEcommerceEvent(
        'add_to_cart',
        {
            currency: product?.currency || GA4_DEFAULT_CURRENCY,
            value: sumItemsValue(items),
            items
        },
        {session_id: usid}
    )
}
